require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-forest-monitoring-what-can-world-bank-others-do.json") })
        }
      }, "path---en-us-update-forest-monitoring-what-can-world-bank-others-do");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-forest-monitoring-what-can-world-bank-others-do!./.cache/json/en-us-update-forest-monitoring-what-can-world-bank-others-do.json
// module id = 664
// module chunks = 231608221292675